module.exports = __webpack_public_path__ + "media/images/ico-chevron-down-c8df3e2e.svg";